module.exports = __webpack_public_path__ + "img/firebase.7f8d489c.svg";